import styled from 'styled-components';
import { Loader as LoaderComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  padding-top: 60px;
  height: 100%;
  background-color: rgb(252,252,252);
`;

export const Loader = styled(LoaderComponent)`
  &&& {
    margin: auto;
  }
`;
